module.exports = __webpack_public_path__ + "img/14.99.04d19cb0.png";